  if (!customElements.get('remove-set-item')) {
  class RemoveSetItem extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.UpdateCart.bind(this));
      this.addEventListeners()
    }
    
    addEventListeners(){
        document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.onClick.bind(this));
    }
    onClick(e){
        e.preventDefault()
        this.cart_inner = document.querySelector('cart-drawer');
        this.cart_inner.classList.remove('is-empty')
        this.cart_inner.classList.remove('active')
        document.body.classList.remove('overflow-hidden');
    }
    UpdateCart(event) {
      event.preventDefault();
      var itemsArray = {};

      const bundle_set = this.closest('.bundle--set');

      bundle_set.querySelectorAll('.remove-set-items-index').forEach(item => {
        var variantId = item.dataset.index;
        var variantqty = item.dataset.qty;
        var quantityInput = 0;
        itemsArray[variantId] = quantityInput;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: itemsArray })
      })
      .then(response => response.json())
      .then(data => {
        this.UpdateCartContent_2();
      })
      .catch(error => {
        console.error('Error updating cart items:', error);
      });
    }
    UpdateCartContent_2(){
      this.cart = document.querySelector('.cart---drawer');
      this.cart_inner = document.querySelector('cart-drawer');
      var cartUrl = `${routes.cart_url}?view=mini`;
      fetch(cartUrl)
        .then((response) => {
          return response.text();
        })
        .then((cartCode) => {
          if (cartCode.trim() === '') {
            return;
          }
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = cartCode;
          var cart_html = tempDiv.querySelector('.cart---drawer');
          console.log(cart_html.innerHTML)
          let cart_count = cart_html.querySelector('.cart---icon-bubble .cart-count-bubble').innerHTML;
          let cart_icon = document.querySelector('header .cart-count-bubble');
          cart_icon.innerHTML = cart_count; 
          this.cart.innerHTML = cart_html.innerHTML;
          
          this.cart.innerHTML = cart_html.innerHTML;
          this.cart.querySelector('cart-drawer').classList.add('active')
          this.cart_inner.classList.add('active')
        });
    }
  }

  customElements.define('remove-set-item', RemoveSetItem);
}
  if(document.querySelector('.non-clickable.active')){
    document.querySelector('.non-clickable.active').addEventListener('click', function(e){
      e.preventDefault()
    })
  }